export interface FormField {
  label?: string;
  placeholder?: string;
  formControlName?: string;
  hint?: string;
  error?: string;
  required?: boolean;
}

/** Options for Select and Radio  */
export interface FieldOption {
  label: string;
  value: any;
  disabled?: boolean;
}

/** Options to activate autocomplete in the inputs */
export enum FieldAutocomplete {
  ON = 'on',
  OFF = 'off'
}
